import { Catalog as e } from "./Catalog.js";
import { CatalogSearch as t } from "./CatalogSearch.js";
import { FacetCollectionConfigurations as n } from "./FacetCollectionConfigurations.js";
import { FacetFieldConfigurations as r } from "./FacetFieldConfigurations.js";
import { FacetPerformanceReportingMetrics as i } from "./FacetPerformanceReportingMetrics.js";
import { FeatureStackConfiguration as a } from "./FeatureStackConfiguration.js";
import { ListingPage as o } from "./ListingPage.js";
import { ListingRulePreview as s } from "./ListingRulePreview.js";
import { ListingRules as c } from "./ListingRules.js";
import { ProductListingConfiguration as l } from "./ProductListingConfiguration.js";
import { ProductListingReportingMetrics as u } from "./ProductListingReportingMetrics.js";
import { RecommendationSlotPreview as d } from "./RecommendationSlotPreview.js";
import { RecommendationsMetrics as f } from "./RecommendationsMetrics.js";
import { RuleDefinition as p } from "./RuleDefinition.js";
import { RulePreview as m } from "./RulePreview.js";
import { Rules as h } from "./Rules.js";
import { SearchMetrics as g } from "./SearchMetrics.js";
import { SlotConfiguration as _ } from "./SlotConfiguration.js";
import { SynonymRulePreview as v } from "./SynonymRulePreview.js";
import { Synonyms as y } from "./Synonyms.js";
import { TrackingIdLocales as b } from "./TrackingIdLocales.js";
import { Setup as x } from "./Setup.js";
import { Audiences as S } from "./Audiences.js";
import { RuleCount as C } from "./RuleCount.js";
import { CatalogFields as w } from "./CatalogFields.js";
import { Resource as T } from "@coveo/platform-client";
//#region src/resources/commerce/Commerce.ts
var E = class extends T {
	constructor(T, E) {
		super(T, E), this.api = T, this.serverlessApi = E, this.audiences = new S(T, E), this.productListingReportingMetrics = new u(T, E), this.productListingConfigurationsV2 = new l(T, E), this.searchMetrics = new g(T, E), this.listingRules = new c(T, E), this.trackingIdLocales = new b(T, E), this.slotConfiguration = new _(T, E), this.recommendationMetrics = new f(T, E), this.recommendationSlotPreview = new d(T, E), this.rules = new h(T, E), this.synonymRulePreview = new v(T, E), this.listingRulePreview = new s(T, E), this.synonyms = new y(T, E), this.catalogSearch = new t(T, E), this.catalog = new e(T, E), this.catalogFields = new w(T, E), this.facetCollectionConfigurations = new n(T, E), this.facetPerformanceReportingMetrics = new i(T, E), this.facetFieldConfigurations = new r(T, E), this.ruleDefinition = new p(T, E), this.rulePreview = new m(T, E), this.setup = new x(T, E), this.listingPage = new o(T, E), this.ruleCount = new C(T, E), this.featureStackConfiguration = new a(T, E);
	}
};
//#endregion
export { E as CommerceResource };

//# sourceMappingURL=Commerce.js.map